export const Window = window;
